module.exports = __webpack_public_path__ + "static/media/img_step_4.13d97051.jpg";